import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { useGame } from '../../context';
import { commitMarker } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&:disabled': { opacity: 0.25 },
    composes: ['is-relative'],
    height: 28,
    marginBottom: 6,
    marginRight: 6,
    width: 28,
  },
  categories: {
    composes: ['flex-columns', 'flex-start'],
    flexWrap: 'wrap',
  },
  wrapper: {
    composes: ['is-absolute'],
    left: 0,
    top: 0,
  },
});

const sortByOrder = (a, b) => {
  if (a.order > b.order) return 1;
  if (a.order < b.order) return -1;
  return 0;
};

const PopupCategoriesComponent = React.memo(({ data }) => {
  const classes = useStyles();
  const { icons } = useGame();
  const dispatch = useDispatch();

  const onCategoryClick = useCallback(
    category => {
      const next = { ...data, category };
      dispatch(commitMarker(next));
    },
    [data, dispatch]
  );

  return (
    <div className={classes.categories}>
      {Object.values(icons)
        .sort(sortByOrder)
        .map(obj => {
          const iscurrent = obj.id === data.category;
          return (
            <button
              key={obj.id}
              className={classes.button}
              disabled={iscurrent}
              type="button"
              onClick={evt => {
                evt.preventDefault();
                onCategoryClick(obj.id);
              }}>
              <div className={classes.wrapper}>
                <obj.Icon
                  background={obj.color}
                  style={{ marginLeft: 0, marginTop: 0 }}
                />
              </div>
            </button>
          );
        })}
    </div>
  );
});

PopupCategoriesComponent.propTypes = {
  data: PropTypes.shape({
    category: PropTypes.string,
    id: PropTypes.string,
    latlng: PropTypes.shape(),
  }).isRequired,
};

PopupCategoriesComponent.displayName = 'PopupCategoriesComponent';

export default PopupCategoriesComponent;
